import React from "react";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import { displayFormattedDate } from "Utils/dateFormats";
import VaultImportModal from "Components/vaultImportModal/VaultImportModal";
import QboxmailApi from "../../../../qboxmailApi.js";

import Button from "Components/button/Button";
import LoaderIcon from "Components/loader/LoaderIcon";
import { Icon, check, attention } from "Icons/index";
import withAutoRefresh from "Components/withAutoRefresh";
import { bytesToHuman } from "Utils/bytesFormats";

import WarningBanner from "Components/warningBanner/WarningBanner";

import cx from "classnames";
import s from "./detailsEmailAccounts.scss";

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vaultImportModalOpened: false,
      areFoldersLoading: true,
      folders: {},
    };
  }

  UNSAFE_componentWillMount() {
    this.setState({ errorGettingFolders: false });
    let client = new QboxmailApi({ useCookie: true });

    client
      .getArchiveImportFolders(this.props.match.params.emailCode)
      .then((data) => {
        this.setState({ areFoldersLoading: false, folders: data.resources[0] });
      })
      .catch((err) => {
        if (err.status === 500) {
          this.setState({ errorGettingFolders: true, areFoldersLoading: false });
        }
      });

    const { emailAccount } = this.props;
    this.props.setInitialValues({
      retention: emailAccount.retention,
    });
  }

  closeVaultImportModal = () => {
    this.setState({ vaultImportModalOpened: false });
  };

  openVaultImportModal = () => {
    this.setState({ vaultImportModalOpened: true });
  };

  getImportStatusText = () => {
    const { emailAccount } = this.props;
    if (emailAccount.archive_import_status === "done_with_errors") {
      return (
        <div className={cx("inputFull2", s.importBox, s.warning)}>
          <Icon className={s.iconImport} svg={attention} width="3rem" height="3rem" />
          <div className={s.textImport}>
            <TranslatedString>archive.import.faileMsg</TranslatedString>
          </div>

          {this.props.isLoggedUserAdmin && emailAccount.imapsync_errors && (
            <div className={s.logFiles}>
              <div className={s.titleLogFiles}>Logfile</div>
              {emailAccount.imapsync_errors.map((err) => (
                <div className={s.logFile} key={err}>
                  {err}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    } else if (emailAccount.archive_import_status === "done") {
      return (
        <div className={cx("inputFull2", s.importBox, s.success)}>
          <Icon className={s.iconImport} svg={check} width="3rem" height="3rem" />
          <div className={s.textImport}>
            <TranslatedString>archive.import.successMsg</TranslatedString>
          </div>
        </div>
      );
    } else if (emailAccount.archive_import_status === "running") {
      return (
        <div className={cx("inputFull2", s.importBox, s.loading)}>
          <LoaderIcon className={s.iconImport} iconSize="3rem" />
          <div className={s.textImport}>
            <TranslatedString>archive.import.loadingMsg</TranslatedString>
          </div>
        </div>
      );
    } else {
      return (
        <div className="inputFull2">
          <WarningBanner msg={t("archive.import.warningMsg")} />
        </div>
      );
    }
  };

  goToDelegate = (e) => {
    e.preventDefault();
    this.props.router.push(`/delegates/${e.target.dataset.code}`);
  };

  render() {
    const { emailAccount } = this.props;
    const { vaultImportModalOpened } = this.state;
    return (
      <div className={s.registry}>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.archive.info.title")}</div>
            </div>
            <div className="formsSectionSP">
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.archive.start")}</div>
                <div className={s.dataRecapt}>
                  {emailAccount.archive_activated_at && displayFormattedDate(emailAccount.archive_activated_at)}
                </div>
              </div>
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.archive.quota")}</div>
                <div className={s.dataRecapt}>{emailAccount.vault_quota_human}</div>
              </div>
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.archive.messages")}</div>
                <div className={s.dataRecapt}>{emailAccount.vault_messages}</div>
              </div>
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.archive.import")}</div>
                <div className={s.dataRecapt}>
                  {emailAccount.archive_import_status
                    ? displayFormattedDate(emailAccount.archive_import_executed_at)
                    : "-"}
                </div>
              </div>
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.archive.delegates")}</div>
                <div className={cx(s.dataRecapt, s.delegateRecap)}>
                  {(emailAccount.delegates || []).map((del) => (
                    <div className={s.delegateName} onClick={this.goToDelegate} data-code={del.code} key={del.code}>
                      <div>{del.fullname}</div>
                      <div className={s.delegateEmail}>{del.email_address}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.archive.import.title")}</div>
              <div className="sectionDesc">
                <div>{t("settings.sections.archive.import.desc")}</div>
                <Button className={s.btnDocsImport} docsKey="archive_emailAccount_import" color="docs">
                  button.docs
                </Button>
              </div>
            </div>
            <div className="formsSectionSP">
              {this.getImportStatusText()}

              {!emailAccount.archive_import_status && (
                <Button onClick={this.openVaultImportModal}>button.startImport</Button>
              )}
            </div>
          </div>
        </div>
        <VaultImportModal
          opened={vaultImportModalOpened}
          handleClose={this.closeVaultImportModal}
          areFoldersLoading={this.state.areFoldersLoading}
          errorGettingFolders={this.state.errorGettingFolders}
          emailCode={this.props.match.params.emailCode}
          emailRetention={emailAccount.retention}
          folders={this.state.folders}
          changeArchiveImportStatus={this.props.changeArchiveImportStatus}
        />
      </div>
    );
  }
}

const refreshConditionFunc = (props) => {
  return props.emailAccount.archive_import_status === "running";
};

const onRefreshFunc = (props) => {
  props.refreshEmailAccount(props.match.params.emailCode, props.match.params.domainCode);
};

export default withAutoRefresh(Details, refreshConditionFunc, onRefreshFunc);
